export interface CountryEntity {
  id: string;
  name: string;
}

export enum CountryRiskLevelType {
  Prohibited = 'Prohibited',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}
